// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"analyticsCard_cardContainer__2U_Qp","mainLabel":"analyticsCard_mainLabel__UD8Qo","subLabel":"analyticsCard_subLabel__2VbpO"};